import { render, staticRenderFns } from "./InstitucionalContent.vue?vue&type=template&id=cd925a04&"
import script from "./InstitucionalContent.vue?vue&type=script&lang=js&"
export * from "./InstitucionalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports